import React, { Component } from 'react';
import ReactTable from "react-table-6";
import "react-table-6/react-table.css";

class UtteranceBasedPricing extends Component {
    constructor() {
        super();
        this.state = {
            data: [
                {
                    noOfIncomingUtterance: "0-5000",
                    price: "Free"
                },
                {
                    noOfIncomingUtterance: "5000 to  2 Lakhs",
                    price: "₹ 0.15"
                },
                {
                    noOfIncomingUtterance: "2 Lakhs and above",
                    price: "₹ 0.10"
                }
            ]
        }
    }

    goBackToProjectPlanPage = () => {
        this.props.history.push('/project-plan-settings');
    }

    render() {
        const columns = [
            {
                Header: () => (<div style={{ textAlign: "center" }}><b>Number of Incoming Utterances</b></div>),
                accessor: 'noOfIncomingUtterance',
                sortable: false,
                style: { textAlign: "center" },
                Cell: props => (<div className="input"
                    style={{ width: '98%', padding: '8px', textAlign: "center" }}
                    type="text"
                >{props.original.noOfIncomingUtterance}</div>
                )
            },
            {
                Header: () => (<div style={{ textAlign: "center" }}><b>Price per Utterance</b></div>),
                accessor: 'price',
                sortable: false,
                Cell: props => (<div className="input"
                    style={{ width: '98%', padding: '8px', textAlign: "center" }}
                    type="text"
                >{props.original.price}</div>
                )
            },
        ]
        return (<div>
            <link href="assets/css/ej2-base.css" rel="stylesheet" />
            <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
            <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
            <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
            <link rel="stylesheet" href="assets/css/ReactToastify.css" />
            <link rel="stylesheet" href="./plugins/font-awesome/css/font-awesome.min.css" />
            <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
            <link rel="stylesheet" href="./assets/css/adminlte.css" />
            <link rel="stylesheet" href="./assets/css/styles.css" />
            <link rel="stylesheet" href="./assets/css/custom-style.css" />
            <link rel="stylesheet" href="./plugins/iCheck/all.css" />
            {/* for reactTable */}
            <link rel="stylesheet" href="./assets/css/React_Table_CSS/react-table.css" />
            <link rel="stylesheet" href="./assets/css/react-table-height.css" />


            <div className="wrapper ">
                <div className="">
                    <div className="row">
                        <div className="col-12">
                            <div className="">
                                <div className="card-body " style={{ padding: '2.5% 2.5% 2.5% 2.5%' }}>
                                    <div className="row">
                                        <div className="col-2"></div>
                                        <div className="col-8" style={{
                                            padding: "70px", border: "1px solid",
                                            borderRadius: "10px"
                                        }}>
                                            <a className="navbar-brand" href="https://www.dhee.ai"></a>
                                            <div className="row">
                                                <img src="assets/images/dheeai.png" alt="" style={{ height: "53px", width: "150px" }} />
                                                <span className="signinTitle" style={{ marginLeft: "200px", Align: "right" }} ><b>UTTERANCE BASED PRICING</b></span>
                                            </div>
                                            <ReactTable
                                                data={this.state.data}
                                                columns={columns}
                                                defaultPageSize={3}
                                                showPagination={false}
                                                style={{
                                                    backgroundColor: 'white',
                                                    marginTop: '25px'
                                                }}
                                            />
                                            <div Align="center" style={{ marginTop: "40px" }}>
                                                <button className="btn btn-primary saveChangesBtn"
                                                    title="Back" onClick={this.goBackToProjectPlanPage}>
                                                    Back
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        )
    }
}
export default UtteranceBasedPricing;



// WEBPACK FOOTER //
// ./src/projectmgmt/settings/pricingDetails/UtteranceBasedPricing.js